import React, { FunctionComponent, EventHandler, MouseEvent } from 'react';
import { Label, Theme, LabelProps, Colors, Tooltip } from '@inplayer-org/inplayer-ui';
import styled, { StyledComponent, css } from 'styled-components';

// icons
import { IoMdInfinite } from 'react-icons/io';

// utils
import { INFINITE } from '../utils/datePeriodSelection';

interface ActiveLabelProps {
  active?: boolean;
  isInfiniteChecked?: boolean;
}

const ActiveLabel: StyledComponent<'label', Theme, LabelProps & ActiveLabelProps> = styled(Label)`
  position: relative;
  left: 0;
  margin: 0.5rem;

  &:first-child {
    margin-left: 0;
  }

  ${({ isInfiniteChecked }: ActiveLabelProps) =>
    isInfiniteChecked &&
    css`
      color: ${Colors.fontGray};
    `}

  ${({ active }: ActiveLabelProps) =>
    active &&
    css`
      color: ${({ theme }: { theme: Theme }) => theme.palette.primary.main};
    `}
`;

const InfiniteIcon = styled(IoMdInfinite)`
  width: 1.5em;
  height: 1.5em;
`;

const StyledTooltip = styled(Tooltip)`
  position: absolute;
  top: -0.1rem;
`;

interface Props {
  label: string;
  onClick: EventHandler<MouseEvent<any>>;
  active?: boolean;
}

const GrantAccessPeriod: FunctionComponent<Props> = ({ label, onClick, active }) => {
  const isInfiniteChecked = label === INFINITE;
  return (
    <ActiveLabel active={active} onClick={onClick} isInfiniteChecked={isInfiniteChecked}>
      {isInfiniteChecked ? (
        <StyledTooltip placement="top" content="100 year access will be granted.">
          <InfiniteIcon />
        </StyledTooltip>
      ) : (
        label
      )}
    </ActiveLabel>
  );
};

export default GrantAccessPeriod;
